import { FC } from 'react';
import SignatureMain from '@/common/components/base/signatureCanvas/SignatureMain.tsx';
import { token } from 'styled-system/tokens';
import { css } from 'styled-system/css';
import SignatureWrapper from '@/common/components/base/signatureCanvas/SignatureWrapper.tsx';
import RefreshSign from '@/common/components/base/signatureCanvas/signActions/RefreshSign.tsx';
import { UseSignatureReturn } from '@/common/hooks/useSignature.ts';
import { Box } from 'styled-system/jsx';

const SignatureDrawingPad: FC<UseSignatureReturn> = (props) => {
  const { signatureRef, onDrawingStop } = props;
  return (
    <SignatureWrapper>
      <Box width="100%" height="calc(100% - 40px)">
        <SignatureMain
          ref={signatureRef}
          className={css({
            width: '100%',
            height: '100%',
          })}
          penColor={token('colors.black')}
          onEnd={onDrawingStop}
        />
      </Box>
      <RefreshSign {...props} />
    </SignatureWrapper>
  );
};

export default SignatureDrawingPad;
